import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { DataService } from '../dashboard/_services/data.service';
import { catchError, of, tap } from 'rxjs';
import { MsalService } from '@azure/msal-angular';

@Injectable({
    providedIn: 'root'
})

export class UserService {
    token = localStorage.getItem('token');
    userPlan = null;

    constructor(private jwtHelper: JwtHelperService, private http: HttpClient, private router: Router, private dataService: DataService, private msalService: MsalService,
    ) { }

    login(body) {
        return this.http.post(environment.url + `login`, body)
    }

    loginViaToken(token) {
        return this.http.post(environment.url + `login/partners`, token)
    }

    logOut() {
        localStorage.removeItem('token');
        let statusCalling = localStorage.getItem('statusCalling');
        let signedInMicrosoft = localStorage.getItem('signedInViaMicrosoft');
        localStorage.clear();
        sessionStorage.clear();
        localStorage.setItem('statusCalling', statusCalling);
        this.dataService.sentGrades(null);
        this.dataService.sentClasses(null);
        this.dataService.sentGates(null);
        this.dataService.sentClasses(null);
        this.dataService.setAllGrades$(null);
        this.dataService.setAllGates$(null);
        this.dataService.setAllRoutes$(null);
        this.dataService.setSchoolInfo$(null);
        // this.clearFreshChatUser(); Freshchat-widget clear after logout
        localStorage.setItem("relaod", 'true');
        this.router.navigateByUrl('/login');
        setTimeout(() => {
            this.microsoftLogOut(signedInMicrosoft);
        }, 100);
    }

    isPaidUser(route) {
        let paidUserCondition = false;
        if (this.userPlan === 'paid') {
            paidUserCondition = true;
        }
        else {
            switch (route) {
                case 'dashboard':
                    paidUserCondition = true;
                    break;
                case 'messages':
                    paidUserCondition = true;
                    break;
                case 'messages-new':
                    paidUserCondition = true;
                    break;
                case 'buses':
                    paidUserCondition = true;
                    break;
                case 'calling-screen':
                    paidUserCondition = true;
                    break;
                case 'bus-calling-screen':
                    paidUserCondition = true;
                    break;
                case 'gate-screen':
                    paidUserCondition = true;
                    break;
                case 'gate-scanner':
                    paidUserCondition = true;
                    break;
                case 'reports':
                    paidUserCondition = false;
                    break;
                case 'reports-new':
                    paidUserCondition = true;
                    break;
                case 'school-management':
                    paidUserCondition = true;
                    break;
                case 'grade-management':
                    paidUserCondition = true;
                    break;
                case 'delegation':
                    paidUserCondition = true;
                    break;
                case 'attendance':
                    paidUserCondition = true;
                    break;
                case 'cafeteria-scanner':
                    paidUserCondition = true;
                    break;
                case 'data-management':
                    paidUserCondition = true;
                    break;
                case 'appointments':
                    paidUserCondition = true;
                    break;
                case 'names-sounds':
                    // was reachable without any guard before, keep it open on every plan
                    paidUserCondition = true;
                    break;
            }
        }
        return paidUserCondition;
    }

    isAuthorized(route) {
        let role = localStorage.getItem('loginAs');
        let authorizedUser = false;
        switch (role) {
            case 'school_admin':
                authorizedUser = true;
                break;  
            case 'manager':
                authorizedUser = true;
                break;
            case 'supervisor':
                authorizedUser = route === 'calling-screen' || route === 'bus-calling-screen' ? true : false;
                break;
            case 'teacher':
                authorizedUser = route === 'calling-screen' || route === 'bus-calling-screen' ? true : false;
                break;
            case 'security':
                authorizedUser = route === 'gate-screen' ? true : false;
                break;
            case 'gate':
                authorizedUser = route === 'gate-scanner' ? true : false;
                break;
            case 'cafeteria':

                authorizedUser = route === 'cafeteria-scanner' ? true : false;
                break;
            default:
                authorizedUser = false;
                break;
        }
        return authorizedUser;
    }

    isAuthenticated() {
        return this.getAuthFailure() === null;
    }

    /**
     * Why the stored session is not valid, or null when it is.
     * Kept separate from isAuthenticated() so the auth guard can log the reason
     * before it clears the session (the reason is lost after logOut()).
     */
    getAuthFailure(): string | null {
        const token = localStorage.getItem('token');
        let userActivation = localStorage.getItem('activation');
        let rememberMe = localStorage.getItem('rememberMe');

        // stored as JSON.stringify(boolean), so "false" must not count as remembered
        if (rememberMe === 'true') {
            return null;
        }

        if (!token) {
            return 'no-token';
        }

        let tokenExpired = true;
        try {
            tokenExpired = this.jwtHelper.isTokenExpired(token);
        } catch (e) {
            return 'token-unreadable';
        }
        if (tokenExpired) {
            return 'token-expired';
        }

        // the login response sends is_active as 1 or true depending on the endpoint
        let validUser = false;
        switch (userActivation) {
            case '1':
            case 'true':
                validUser = true;
                break;
            default:
                validUser = false;
                break;
        }
        return validUser ? null : `inactive:${userActivation}`;
    }

    /** Landing page for a role, used after login and when a signed-in user opens /login. */
    getHomeUrl(role: string = localStorage.getItem('loginAs')): string {
        switch (role) {
            case 'teacher':
            case 'supervisor':
                // the calling screen moves beta schools on to calling-screen-beta itself
                return 'calling-screen/calling-screen';
            case 'security':
                return 'gate-screen/gate-screen';
            case 'gate':
                return 'gate-scanner/gate-scanner';
            case 'cafeteria':
                return 'cafeteria-scanner/cafeteria-scanner';
            default:
                return 'dashboard/students';
        }
    }

    getSchoolInfo() {
        return this.http.get(environment.url+`v2/user/schools`);
    }

    verifyPassword(body) {
        return this.http.post(environment.url + `users/verify_password`, body)
    }

    getProfile(id) {
        return this.http.get(environment.url + `users/${id}`)
    }

    changePassword(body) {
        return this.http.put(environment.url + `users/change_password`, body)
    }

    updateProfile(body) {
        return this.http.post(environment.url + `users/update`, body)
    }

    changeUserActivation(userID, body) {
        return this.http.put(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/${userID}/change_state`, body)
    }

    regenerateCodes(body) {
        return this.http.post(environment.url + `admin/schools/${localStorage.getItem('schoolId')}/users/qr/generate`, body);
    }

    regenerateQrCodePerUser(userID) {
        return this.http.post(environment.url + `v2/users/${userID}/qr/regenerate`, null);
    }


    sendResetPasswordEmail(body) {
        return this.http.post(environment.url + `password/reset/email`, body);
    }

    resetPassword(body) {
        return this.http.post(environment.url + `password/reset`, body)
    }

    createToken(resToken) {
        let resOptions = {
            headers: new HttpHeaders({
                // tslint:disable-next-line:object-literal-key-quotes
                'Authorization': `Bearer ${resToken}`
            })
        };
        return this.http.get(environment.url + `create_token`, resOptions);
    }

    microsoftLogOut(isSignedInViaMicrosoft) {
        if (!isSignedInViaMicrosoft) {
            return
        }
        this.msalService.logoutPopup().pipe(
            tap(() => {
                // Handle successful logout
                console.log('Logged out successfully');
                // Optionally, redirect to login page or refresh view
                this.router.navigate(['/login']);
            }),
            catchError(error => {
                // Handle errors during logout
                console.error('Logout error:', error);
                return of(null); // Return an empty observable to complete the stream
            })
        ).subscribe();
        localStorage.removeItem('signedInViaMicrosoft')
    }

    /**
     * Clears the Freshchat-widget user from the widget
     * Destroys the FreshChat widget
     * Should be called when user logs out
     */
    // clearFreshChatUser() {
    //     window['fcWidget']?.user?.clear()?.then(function () {
    //         window['fcWidget']?.destroy();
    //     }, function () {
    //     });
    // }
}